import { css } from 'styled-components';

import { outerFocusMixin } from 'components/FocusVisibility/styles';

export const defaultLinkStyles = css`
    ${outerFocusMixin};
`;
